import { render, staticRenderFns } from "./RowExtraInfo.vue?vue&type=template&id=37443b9e&scoped=true&"
import script from "./RowExtraInfo.vue?vue&type=script&lang=js&"
export * from "./RowExtraInfo.vue?vue&type=script&lang=js&"
import style0 from "./RowExtraInfo.vue?vue&type=style&index=0&id=37443b9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37443b9e",
  null
  
)

export default component.exports